import {
  login,
  loginRedirect,
  logout,
  requestStorageAuth,
  silentlyRefreshSession
} from './auth'
import startTokensRefreshingProcess from './startTokensRefreshingProcess'

export default {
  login,
  loginRedirect,
  logout,
  requestStorageAuth,
  startTokensRefreshingProcess,
  silentlyRefreshSession,
}

export { stopTokensRefreshingProcess } from './startTokensRefreshingProcess'
